import { useEffect } from "react";
import { BRAND } from "../../types";

interface ContactForm {
  name: string;
  phone: string;
  email: string;
}

interface ContactInfoProps {
  contact: ContactForm;
  /** 订单详情中的联系人（用于回显） */
  defaultContact?: { name: string; phone: string; email?: string };
  onChange: (contact: ContactForm) => void;
}

export function ContactInfo({ contact, defaultContact, onChange }: ContactInfoProps) {
  // 当订单详情返回时，自动回填联系人信息
  useEffect(() => {
    if (defaultContact && !contact.name && !contact.phone) {
      onChange({
        name: defaultContact.name || "",
        phone: defaultContact.phone || "",
        email: defaultContact.email || "",
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultContact]);

  const update = (field: keyof ContactForm, value: string) => {
    onChange({ ...contact, [field]: value });
  };

  return (
    <div className="rounded-2xl p-4" style={{ background: "#fff" }}>
      <div className="text-sm font-bold text-gray-900 mb-3">
        <i
          className="ri-user-line mr-1.5"
          style={{ color: BRAND, fontSize: 15 }}
        />
        联系人信息
      </div>
      <div className="space-y-2.5">
        {[
          { icon: "ri-user-line", ph: "联系人姓名", field: "name" as const, val: contact.name },
          { icon: "ri-phone-line", ph: "联系电话", field: "phone" as const, val: contact.phone },
          { icon: "ri-mail-line", ph: "邮箱地址（接收凭证）", field: "email" as const, val: contact.email },
        ].map((f) => (
          <div
            key={f.ph}
            className="flex items-center gap-3 px-3.5 py-3 rounded-xl"
            style={{ background: "#F8F9FC", border: "1px solid #F0F0F0" }}
          >
            <i
              className={f.icon}
              style={{ color: "#C0C4CC", fontSize: 16 }}
            />
            <input
              className="flex-1 bg-transparent outline-none text-sm text-gray-700"
              placeholder={f.ph}
              value={f.val}
              onChange={(e) => update(f.field, e.target.value)}
              style={{ fontSize: 14 }}
            />
          </div>
        ))}
      </div>
    </div>
  );
}
